import { inject } from "@angular/core";
import { CanMatchFn, Route, UrlSegment } from "@angular/router";

import { map } from "rxjs";

import {
    AUTHORIZATION_TO_AGEC_PAGE,
    FeatureFlagFacade,
} from "@hermes/hermes-web-states-flipper-state";

export function canMatchAgecPage(): CanMatchFn {
    return (_route: Route, _segments: UrlSegment[]) => {
        const featureFlagFacade = inject(FeatureFlagFacade);

        return featureFlagFacade
            .isActivated(AUTHORIZATION_TO_AGEC_PAGE)
            .pipe(map((enabled) => enabled));
    };
}
